export enum CampaignStatusEnum {
  Draft = 1,
  Live = 2,
  Finished = 3,
}
